import { firestoreWrapper } from './firestoreWrapper';

const COLLECTION = 'userHiddenApps';
const CACHE_TTL = 30_000;

interface CacheEntry {
  data: string[];
  timestamp: number;
}

const cache = new Map<string, CacheEntry>();

export async function getHiddenApps(email: string): Promise<string[]> {
  const key = email.toLowerCase();
  const now = Date.now();
  const cached = cache.get(key);
  if (cached && now - cached.timestamp < CACHE_TTL) return cached.data;

  const docRef = firestoreWrapper.doc(firestoreWrapper.collection(COLLECTION), key);
  const snap = await firestoreWrapper.getDoc(docRef);
  const hiddenApps: string[] = snap.exists()
    ? (snap.data() as { hiddenApps: string[] }).hiddenApps ?? []
    : [];

  cache.set(key, { data: hiddenApps, timestamp: now });
  return hiddenApps;
}

export async function hideApp(email: string, appId: string): Promise<void> {
  const key = email.toLowerCase();
  const current = await getHiddenApps(key);
  if (current.includes(appId)) return;

  const updated = [...current, appId];
  const docRef = firestoreWrapper.doc(firestoreWrapper.collection(COLLECTION), key);
  await firestoreWrapper.setDoc(docRef, { hiddenApps: updated } as any, { merge: true });
  cache.set(key, { data: updated, timestamp: Date.now() });
}

export async function unhideApp(email: string, appId: string): Promise<void> {
  const key = email.toLowerCase();
  const current = await getHiddenApps(key);
  if (!current.includes(appId)) return;

  const updated = current.filter((id) => id !== appId);
  const docRef = firestoreWrapper.doc(firestoreWrapper.collection(COLLECTION), key);
  await firestoreWrapper.setDoc(docRef, { hiddenApps: updated } as any, { merge: true });
  cache.set(key, { data: updated, timestamp: Date.now() });
}

export function clearHiddenAppsCache(): void {
  cache.clear();
}
